import { SafeUrl } from '@angular/platform-browser';
import {
  AudioContentModel,
  FileContentModel,
  LocationContentModel,
  MessageModel,
} from '@sestek/common/components';
import { Encoding } from '@sestek/common/utils';

export interface ActivityModel {
  id?: string;
  type?: string;
  attachmentLayout?: string;
  text?: string;
  attachments?: AttachmentModel[];
  entities?: EntityModel[];
  channelData?: ChannelDataModel;
}

export interface AttachmentModel {
  contentType?: string;
  contentUrl?: string;
  name?: string;
  info?: string;
  hasPrerecordedAudio?: boolean;
  encoding?: Encoding;
  sampleRate?: number;
  messageAttachmentSource?: MessageAttachmentSource;
  messageAttachmentType?: MessageAttachmentType;
  content?: AttachmentContentModel | Blob | string;
  storedExternally?: boolean;
}

export interface AttachmentContentModel {
  title: string;
  subtitle: string;
  text: string;
  images: {
    url: string;
  }[];
  buttons: ButtonModel[];
}

export interface EntityModel {
  type: string;
  address: string;
  geo: {
    latitude: number;
    longitude: number;
    name: string;
  };
  hasMap: string;
}

export interface ChannelDataModel {
  CustomActionData?: string;
  ResponseType?: ResponseType;
  CustomProperties?: {
    sourceAudioId?: string;
    textFromSr?: string;
    isTyping?: string;
    debugInfoCategory?: string;
    debugInfoTitle?: string;
  };
}

export interface ButtonModel {
  type: string;
  text: string;
  title: string;
  value: string;
}

export interface CaiMessageModel extends MessageModel {
  activity?: ActivityModel;
}

export class CustomAudioContentModel extends AudioContentModel {
  encoding?: Encoding;
  sampleRate?: number;
  hasPrerecordedAudio: boolean;
  messageAttachmentSource: MessageAttachmentSource;
  storageLocation: StorageLocation;
}

export interface CustomFileContentModel extends FileContentModel {
  messageAttachmentSource: MessageAttachmentSource;
  messageAttachmentType: MessageAttachmentType;
}

export interface CustomLocationContentModel extends LocationContentModel {
  src?: SafeUrl;
}

export interface TestChatSettings {
  ['AgentMonitoring']: {
    ['ShowResponderAiAgentName']: boolean;
    ['ShowAiAgentToolCallDetails']: boolean;
  };
  ['AudioResponse']: {
    ['EnableAudioResponses']: boolean;
  };
  ['VoiceActivityDetection']: {
    ['EnableInterruptionWhileTalking']: boolean;
    ['PreSpeechBufferLength']: number;
    ['PostSpeechBufferLength']: number;
    ['Sensitivity']: number;
    ['MaxSpeechDuration']: number;
    ['SilenceTriggerDuration']: number;
  };
}

export enum MessageType {
  reply,
  utterance,
  event,
  debugInfo,
}

export enum MessageSource {
  liveChat = 1,
  virtualAgent = 0,
  aiAgent = 2,
}

export enum MessageAttachmentSource {
  file,
  path,
  attachment,
}

export enum MessageAttachmentType {
  document = 'document',
  image = 'image',
}

export enum MessageAttachmentCategory {
  image = 0,
  audio = 1,
  video = 2,
  document = 3,
  other = 4,
}

export enum StorageType {
  customerVoice,
  agentVoice,
  fileResponse,
  audioFileResponse,
  audioPathResponse,
  customerAttachment,
  documentFilePathResponse,
  imageFilePathResponse,
  agentAttachment,
}

export enum ResponseType {
  text = 'Text',
  audioBase64 = 'AudioBase64',
  audioMinio = 'AudioMinio',
  audioMultiPart = 'AudioMultiPart',
}

export enum StorageLocation {
  internal,
  external,
}
